/**
 * Copyright (c) 2024, Mohamed eRrais (merrais / MeR)
 * mohamed@errais.net
 * https://ocr.1ai.ma, https://akademy.ma, https://digitalservices.ma, https://sites.errais.net, https://2us.ma, 
 * محمد الرايس
 * Rais Digital Services
 * 240704 2333 : From ToTable tajwyd.akademy.ma
 * + from Database.php GetResponse
 * ResultView From TableView ocr.1AI.ma
**/

import React,{useState, useEffect, useLayoutEffect} from 'react'
import '../meTable/meTable.css'
import Api, {Get} from '../Api'
import {ToFormat} from  'fast_inon'
import EvalModal from './EvalModal'
import {ToId, InOption} from './EvalControl'
import {onUpdate, onCell} from './EvalAction'
import {OnExport, OnAction, OnCRUD} from '../Shared/ActionControl'

import {meResults} from '../Shared/meLayout'

const EvalView = ({parent, options, onChange, Message, role=2}) => {

    const [loaded, Load] = useState(false)
    const [editable, Edit] = useState('false')
    const [fields, Fields]= useState([])
    const [items, Items]= useState([])
    const [clicked, Clicked] = useState({n:0,x:0,y:0,now:new Date()})
    const [selected, Select] = useState({entity:parent.entity, id:0, field:'', value:''})
    const [modal, Modal] = useState({show:false, member:0, planned:0})

    const [layouts, Layouts]= useState([])
    const [comments, Comments]= useState([])

    const detail =  parent?.level?.endsWith('4')

    const resizer = new meResults(selected.entity)
    useLayoutEffect (()=>{  
        //alert(selected.entity)
        resizer.selectorAll() 

        if(layouts.length>0) {
            layouts.forEach((item) => {
                resizer.SetCoord(item.Name, item.Coord)
            })
        }
        //alert(comments.length)
    })

    useEffect(()=>{
        if(loaded) {
            Load(false)
        }
    }, [parent])

    useEffect(() => {
        //alert(parent.level)
        if(!loaded && parent?.request?.length>0) {
            Items([])
            //alert(parent.request)
            Api.get(parent.request)
            .then(response => {
                if(response.data?.length>0) {
                    Items(response.data)
                    Fields(Object.keys(response.data[0]))
                    Load(true)
                }
            })
            .catch(error => {
                Message && Message(error)
            })

            Get(`/Layout/${parent.entity}`, Layouts,null,Message)

            if(detail) {
                // Get(`${parent.entity}/${parent.id}/Comment`, Comments,null,Message)
            }
        }

        if(items?.length>0) {
            items.forEach(item => {
                item.Checked = false
            })
            //console.log('items',items.length)
        }    

    }, [loaded, parent?.request])

      
    useEffect(()=>{
        if(selected.id>0) {
            Etat(`${selected.entity} [${selected.field}-${selected.id}] = ${selected.value}`)
        }

        onChange && onChange(selected)
        //navigator?.clipboard?.writeText(selected.value)
        //onRefresh()

    }, [selected])

    const Etat = (message) => {
        var etat = document.getElementById("EtatApp")
        if(etat)
            etat.innerHTML = message
    }
    
    const onSelect = (e, id) => {
        const object = e?.target
        if(object) {
            const field = object.title.substring(0, object.title.indexOf('= '))
            Select({...selected, id:id, field:field, value:object.innerText})

            onCell(e, clicked, Clicked)
        }
    }

    const onOption = (e) => {
        //Message(e.target.value)
    }

    const getOptions = (question) => {
        // "Attendance","Listening","Review"
        switch(question){
            case "Attendance":
                return options.filter(o => o.Parent===1)
                
            case "Listening":
                return options.filter(o => o.Parent===2)  

            case "Review":
                return options.filter(o => o.Parent===3)
        }
    }

    const onCheck = (e, id) => {
        items.filter(item=>{
            return (item.Id===id)
        })
        .map(item => { 
            item.Checked = !item.Checked
            return item.Checked
        })

        
        const td = e.target.parentElement
        if(td.tagName==='TD') {
            if (td.classList.contains('checked')) {
                td.classList.remove('checked')
            }
            else {
                td.classList.add('checked') 
            }
        }
        //console.log('onCheck', id, td.className)
        
        Select({...selected, id:id, field:'Id', value:id})
    }

    const onRefresh = (e) => {
        Load(false)
    }

    const onAdd = (e) => {
        //alert('Add')
    }

    
    const onMaximize = (e) => {
        //alert(`${e?.target.title}`) //console.log(e, e.src)
        const table = document.getElementById(`${selected.entity}Table`)
        if(table) {
            if(e.target.alt==="Minimize") {
                e.target.alt="Maximize"
                e.target.className="fa fa-window-maximize"
                table.style.height=0
            }
            else {
                e.target.alt="Minimize"
                e.target.className="fa fa-window-minimize"
                table.style.height="auto"
            }
        }
    }

    const [data, Data] = useState(null)
    const onExport = () => {
        //let request="Export/Registering"+"/"+tab
         Api.get(parent.request+"_Report").then(response => {
            Data(response.data)
            //console.log('Api.Get', request, response)
        })
        .catch(error => {
            Message && Message(error)
        })
    } 

    
    return (
<div className="element" id={`${selected.entity}Element`}>
<div className="row results-head">   
    <div className="col-sm-1">
        <OnAction onMaximize={onMaximize} />
    </div>             
    <div className="col-sm-8"> 
        <div className="results-name">{selected.entity}</div>
    </div>   
    <div className="col-sm-1">
        <OnAction onRefresh={onRefresh} />
    </div>             
    <div className="col-sm-1">
        <OnAction onCreate={onAdd} />
    </div>             
    <div className="col-sm-1">
        <OnExport onFetch={onExport} data={data} name={`Report_${selected.entity}.csv`} />  
    </div>           
</div>        
        
{ loaded //&& items?.length>0 && fields.length>0
?

<div className="results" 
        onMouseDown={(e)=>{resizer.mouseDown(e)}} 
        onMouseMove={(e)=>{resizer.mouseMove(e)}} 
        onMouseUp={(e)=>{resizer.mouseUp(e, Api)}}
> 
<table className='styled-table' id={`${selected.entity}Table`}>
    
<thead id={`${selected.entity}Head`}>
    <tr>
        {
            fields.map(field=>
                <th id={`Th-${field}`} entity={selected.entity}>{field}</th>
            )
        }

        { detail ?
        <th id={`Th-Actions`} entity={selected.entity}></th>
        : null }

    </tr>
</thead>

<tbody id={`${selected.entity}Body`}>
{
    items.map(item=>
        <tr key={item.Id}>

{ Object.values(item).map((value,index) => (
    
    index===0 ? 
        <ToId value={value} onClick={onCheck} checked={item?.Checked} />
    : (
        fields[index]?.endsWith('At') ?
        <td style={{textAlign:'right', color:'darkblue'}}>{ToFormat(value)}</td>
        : (

            onChange && ["Attendance","Listening","Review"].includes(fields[index]) ?
            <td style={{textAlign:'right'}}>
                <InOption items={getOptions(fields[index])} 
                    defaultValue={value??""} 
                    member={item.Id} planned={parent.id} 
                    onChange={onOption} readOnly={role!==2} Message={Message} />
            </td>
            : (
                index<fields.length ?
            <td className="editable" contentEditable={editable} id={`Item-${item.Id}-${fields[index]}`} key={`Item-${item.Id}-${fields[index]}`}
                title={`${fields[index]}= ${value}`} 
                value={value}
                defaultValue={value}
                onClick={(e) => onSelect(e, item.Id)} 
                onKeyUp={e => onUpdate(e, selected, Message)} >
            {value}</td>
            :null

            )
        )
    ) 
)) }


{ detail ?
<OnCRUD 
    onEdit={()=> {
        //  alert(`modal M:${item.Id} P:${parent}`)
        Modal({show:true, member:item.Id, planned:parent.id })
    }} 
/>
: null }

    </tr>
            )
}
</tbody>
</table>
</div>

:
<h5>{selected.entity}</h5>
}

<div className="row results-foot">
    <div className="col-sm-3">
        <p id="EtatStat">Ready</p>
    </div>

    <div className="col-sm-6">
        <p id="EtatApp">...</p>
    </div>
    <div className="col-sm-3 results-rows">
        <p id="results-rows">{items.length} rows</p>
    </div> 
</div>  

{ modal.show && detail ?
<EvalModal item={selected} modal={modal} onHide={()=>Modal({...modal, show:false })} Message={Message} />
: null }

</div>

 )
}



export default EvalView

